import { useEffect } from "react";
import { type TermsAndConditions, hasAcceptedCurrentLegalVersion } from "@akina/domain";
import { useFetchLegalPage } from "./useFetchLegalPage";

export const useNavigateToTermsAndConditions = (params: {
  isDeepLinkHandled: boolean;
  terms: TermsAndConditions | undefined | null;
  setTermsModalOpen: (open: boolean) => void;
  setPrivacyPolicyModalOpen: (open: boolean) => void;
  setTermsAndPrivacyPolicyModalOpen: (open: boolean) => void;
}) => {
  const { isDeepLinkHandled, terms, setTermsModalOpen, setPrivacyPolicyModalOpen, setTermsAndPrivacyPolicyModalOpen } =
    params;

  const { data: termsAndConditionsLegalPage } = useFetchLegalPage(
    "terms-and-conditions",
    "care",
    undefined,
    isDeepLinkHandled,
  );
  const { data: privacyPolicyLegalPage } = useFetchLegalPage(
    "privacy-policy-and-data-transparency",
    "care",
    undefined,
    isDeepLinkHandled,
  );
  useEffect(() => {
    if (!isDeepLinkHandled) return;
    if (terms && privacyPolicyLegalPage && termsAndConditionsLegalPage) {
      const { privacyPolicyAccepted, termsAndConditionsAccepted } = hasAcceptedCurrentLegalVersion(
        termsAndConditionsLegalPage,
        privacyPolicyLegalPage,
        terms,
      );
      if (!privacyPolicyAccepted && !termsAndConditionsAccepted) return setTermsAndPrivacyPolicyModalOpen(true);

      if (!termsAndConditionsAccepted) return setTermsModalOpen(true);
      if (!privacyPolicyAccepted) return setPrivacyPolicyModalOpen(true);

      if (privacyPolicyAccepted && termsAndConditionsAccepted) {
        setTermsAndPrivacyPolicyModalOpen(false);
        setTermsModalOpen(false);
        setPrivacyPolicyModalOpen(false);
      }
    }
  }, [isDeepLinkHandled, termsAndConditionsLegalPage, privacyPolicyLegalPage, terms]);
};
